import styled from "styled-components";

type SpacingProps = {
  $vertical?: string;
  $horizontal?: string;
};

export const SpacingDiv = styled.div<SpacingProps>`
  width: 0px;
  height: 0px;
  padding: 0px;
  margin: 0px ${({ $horizontal }) => ($horizontal ? `${$horizontal}px` : "0px")}
    ${({ $vertical }) => ($vertical ? `${$vertical}px` : "0px")} 0px;
`;
